// extracted by mini-css-extract-plugin
module.exports = {"container":"_vp_89EEV","title":"_XQaz_QmW","image":"_t6y87OSV","badge":"__VD-yWrK"};